

export const apiurl = {
    Organization: "/organization",
    Login: "/login",
    Logout: "/logout",
    ForgotPassword: "/forgetPassword",
    VerifyOTP: "/verifyOtp",
    ResendOTP: "/resendOtp",
    ResetPassword:"/resetPassword",
    Dashboard:"/export",
    Importdashboard:"/import",
    Importdashboard_CreateJob:"/import/job",
    Exportdashboard_CreateJob:"/export/job",
    Organization_Dashboard: "/organization",
    Create_Customer: "/create-customer",
    ExportAddress: "/customer/customerAddress", 
    ExportConsignee: "/customer/customerAddress/consignee",
    dashboardEndpoint:"/export",
    Export_data : "/export",
    Import_data:"/import/dashboard",
    SezInfo :"/export/sez/ExportMasterId",
    Entity :"export/entity/ExportMasterId",
    Create_Exporter:"/export/general",
    GetPorts : "/shipment/portMaster?type=",
    GetCountry : "/master/country",
    GetQuantity: "/shipment/quantityMaster",
    GetCFS:"/shipment/CFS",
    GetAirline:"/shipment/airlineMaster",
    Update_Exporter : "/export/general",
    GetCity : "/master/city",
    GetState : "/master/state",	
    GetVolume: "/shipment/volumeMaster",
    Advanced_filter : "/export/filter",
    Import_filter : "/import/filter",
    Organization_filter : "/customers/filter",
    GetDescription:"/master/description",
    GetHsnCodeMaster:"/master/hsnCode",
    GetEndUseCodeMaster:"/master/endUseCode",  
    GetFTAMaster:"/master/fTAInfo",
    GetDistrictMaster:"/master/districts",
    GetRateListMaster : "/master/ratelist",
    GetGateway:"/shipment/gateway",
    GetCustomer: "/customers",
    GetIECode:"/shipment/ieCode",
    GetDrawer:"/master/drawback",
    GetInvoice:"/export/invoice/main",
    GetExchange:"/master/exchangeRate",
    GetCurrencies:"/master/currency", 
    GetInvoiceMaster:"/export/invoice/main",
    GetInvoiceMain:"/export/invoice/main",
    GetLic:"/master/lic",
    GetCustomeHouse:"/master/customHouse",
    GetContactListQuery:"/customers/contact",
    GetShipingLine:"/shipment/shippingLineMaster",
  };
